var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __decorateParam = (index, decorator) => (target, key) => decorator(target, key, index);

// db/import-job.ts
import { A } from "@adornis/base/env-info.js";
import { logger } from "@adornis/base/logging.js";
import { Arg, Entity, Field, Subscription } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import "@adornis/baseql/entities/mongoEntity.js";
import { getRawCollection } from "@adornis/baseql/server/collections.js";
import { createReadStream } from "fs";
import { ReplaySubject } from "rxjs";
import { convertCSVToEntity } from "../server/import-internals.js";
import { ConvertConfig } from "./convert-config.js";
var ImportJob = class extends AdornisEntity {
  constructor() {
    super(...arguments);
    this.logger = new ReplaySubject(10);
    this.resultList = [];
  }
  static convertCSVFromPathToEntity(filePath, convertConfig) {
    return () => {
      const importJob = new this({ convertConfig });
      convertCSVToEntity(createReadStream(filePath), convertConfig, importJob);
      return importJob.logger;
    };
  }
  static convertCSVFromStringToEntity(csvString, convertConfig) {
    return () => {
      const importJob = new this({ convertConfig });
      convertCSVToEntity(csvString, convertConfig, importJob);
      return importJob.logger;
    };
  }
  async synchronousHandler(result, rawData) {
    this.resultList.push(result);
  }
  async asynchronousHandler(result) {
  }
  // eslint-disable-next-line max-statements
  async finish() {
    if (!this.convertConfig.constr._collectionName)
      throw new Error(
        "trying to import but no collection name is present on the entity. If you mean to handle saving yourself, overwrite the finish() method on ImportJob"
      );
    this.logger.next(`writing ${this.resultList.length} entities with respective foreign keys to db...`);
    if (!this.resultList.length)
      return this.logger.next("no entities found which I need to save");
    for await (const fkconfig of this.convertConfig.foreignKeys) {
      if (!fkconfig.constr._collectionName)
        throw new Error(
          "trying to import foreign keyed entity but no collection name is present on the entity. If you mean to handle saving yourself, overwrite the finish() method on ImportJob"
        );
      const resultListToFKEntity = this.resultList.map((result) => {
        const fkEntity = result.foreignKeyData.find((fkd) => fkd.mappingEntry === fkconfig);
        if (!fkEntity)
          throw new Error("invalid state, this should never be allowed to happen");
        return fkEntity;
      });
      const idField2 = fkconfig.uniqueIdentifierFieldName;
      const coll2 = await getRawCollection(fkconfig.constr._collectionName);
      await coll2.bulkWrite(
        resultListToFKEntity.map((fkresult) => ({
          updateOne: {
            filter: {
              _class: fkconfig.className,
              [idField2]: fkresult.entity[idField2]
            },
            update: {
              $set: Object.fromEntries(Object.entries(fkresult.entity).filter(([key]) => key !== "_id")),
              $setOnInsert: { _id: A.getGloballyUniqueID() }
            },
            upsert: true
          }
        }))
      );
      logger.info(
        {
          collName: fkconfig.constr._collectionName,
          idField: idField2,
          entities: this.resultList.length,
          collectionName: fkconfig.constr._collectionName
        },
        "done importing " + fkconfig.keyOnHost
      );
      for (const [index, ensuredForeignKeyEntity] of Object.entries(resultListToFKEntity)) {
        this.resultList[index].entity[fkconfig.keyOnHost] = (await coll2.findOne({
          [idField2]: ensuredForeignKeyEntity.entity[idField2]
        }))?._id;
        if (!this.resultList[index].entity[fkconfig.keyOnHost])
          throw new Error(
            "wasnt able to refetch inserted foreign key data.Fatal error, import has interrupted in the middle of executing foreign key linking"
          );
      }
      this.logger.next(`done importing ${fkconfig.keyOnHost}`);
    }
    const idField = this.convertConfig.uniqueIdentifierFieldName;
    const coll = await getRawCollection(this.convertConfig.constr._collectionName);
    await coll.bulkWrite(
      this.resultList.map((e) => {
        return {
          updateOne: {
            filter: {
              _class: this.convertConfig.className,
              [idField]: e.entity[idField] || A.getGloballyUniqueID()
            },
            update: {
              $set: Object.fromEntries(
                Object.entries(e.entity).filter(([key]) => !this.convertConfig.upsertFieldBlacklist?.includes(key)).filter(([key]) => key !== "_id")
              ),
              // if csv has no unique identifier and we set idField=_id, setOnInsert with _id is not allowed by mongo
              // mongo will use the filter object to set the _id field then and will not allow any updates to the _id field
              ...idField === "_id" ? {} : { $setOnInsert: { _id: A.getGloballyUniqueID() } }
            },
            upsert: true
          }
        };
      })
    );
    logger.info({ entities: this.resultList.length }, "done importing");
    this.logger.next("done importing :)");
  }
};
ImportJob._class = "ImportJob";
__decorateClass([
  Field((type) => ConvertConfig)
], ImportJob.prototype, "convertConfig", 2);
__decorateClass([
  Subscription((type) => String),
  __decorateParam(0, Arg("filePath", (type) => String)),
  __decorateParam(1, Arg("convertConfig", (type) => ConvertConfig))
], ImportJob, "convertCSVFromPathToEntity", 1);
__decorateClass([
  Subscription((type) => String),
  __decorateParam(0, Arg("csvString", (type) => String)),
  __decorateParam(1, Arg("convertConfig", (type) => ConvertConfig))
], ImportJob, "convertCSVFromStringToEntity", 1);
ImportJob = __decorateClass([
  Entity()
], ImportJob);
export {
  ImportJob
};
